import { Stack, Typography, Button, Icon, Divider, List, ListItem } from '@ace-clublabs/shared-component-library';
import { IconName } from '@ace-clublabs/shared-component-library/dist/components/Icons';
import { IAdditionalBenefits } from '@lib/types/dist/IAdditionalBenefits';
import { useEffect, useState } from 'react';

export interface IMembershipBenefitProps {
  className?: string;
  buttonTitle: string;
  buttonVariant?: string;
  buttonOrLinkOnClick: () => void;
  subtitle: string;
  additionalBenefits: IAdditionalBenefits | undefined;
  isButton?: boolean;
}

export const MembershipBenefit = ({
  className,
  buttonTitle,
  buttonVariant,
  buttonOrLinkOnClick,
  subtitle,
  additionalBenefits,
  isButton,
}: IMembershipBenefitProps) => {
  const iconsNames = ['truck-tow-duotone', 'circle-plus-duotone'];
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 769);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mobileListStyles = {
    whiteSpace: 'normal',
    overflow: 'visible',
    minWidth: '292px',
  };

  const listStyle = {
    textIndent: '-1em',
    paddingLeft: '1em',
    lineHeight: '1.5rem',
    fontSize: '1rem',
    color: '#404040',
    fontWeight: '400',
    ...(isMobile ? mobileListStyles : {}),
  };

  const sections = [additionalBenefits?.['group1'], additionalBenefits?.['group2']].filter(Boolean);

  const sectionListFragment = (
    <>
      {sections.map((section, index) => (
        <span key={index}>
          <Stack direction="row" alignItems="flex-start" marginBottom="0.25rem" gap="0.25rem">
            <Icon
              iconName={iconsNames[index] as IconName}
              sx={{ fontSize: '1.25rem', marginTop: '0.25rem', marginRight: '0.25rem', color: '#0C7A93' }}
            ></Icon>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: '500', color: '#0C7A93' }}
              className={`section${index + 1}-title`}
            >
              {section?.title}
            </Typography>
          </Stack>

          <List sx={{ marginTop: '-0.25rem' }}>
            {section?.benefits.map((benefit: any, i: any) => (
              <ListItem sx={{ marginLeft: '0.35rem' }} className="benefit-item-container" key={'ben-' + i}>
                <Typography component={'span'} sx={{ alignSelf: 'baseline', marginRight: '0.5rem' }}>
                  {'\u2022'}
                </Typography>
                <Typography component={'span'} variant="b2Regular">
                  <span dangerouslySetInnerHTML={{ __html: benefit }} />
                </Typography>
              </ListItem>
            ))}
          </List>
        </span>
      ))}
    </>
  );

  return (
    <Stack direction="column" className={`${className}-benefit-container`}>
      {isButton ? (
        <Button
          fullWidth
          className={`${className}-button`}
          label={buttonTitle}
          variant={buttonVariant as any}
          onClick={buttonOrLinkOnClick}
          sx={{ marginTop: '1.5rem', marginBottom: '1.5rem', width: '100%' }}
        />
      ) : (
        <Stack height="3rem" justifyContent="center" marginTop="1.5rem" marginBottom="1.5rem">
          <Divider
            orientation="horizontal"
            className={`${className}-divider`}
            sx={{ width: '2.5rem', alignSelf: 'center' }}
          />
        </Stack>
      )}
      <Typography
        variant="b1Bold"
        sx={{
          marginBottom: '1rem',
          '@media (min-width: 1024px)': {
            height: '3.5rem',
          },
        }}
        className={`${className}-subtitle`}
      >
        {subtitle}
      </Typography>
      <Stack direction="column" gap="0.5rem" className={`${className}-additional-benefits`}>
        {sectionListFragment}
      </Stack>
    </Stack>
  );
};
